import React, { useState, useEffect } from "react";
import {
  DropdownToggle,
  DropdownMenu,
  Dropdown,
  Button,
  Spinner,
} from "reactstrap";
import { Icon } from "../../../../components/Component";
import { LinkList, LinkItem } from "../../../../components/links/Links";
import UserAvatar from "../../../../components/user/UserAvatar";
import { useCookies } from "react-cookie";
// import { useHistory } from "react-router-dom";
import { servicePutUsersOffline, serviceToggleUserStatus } from "services/users";
import { unsubscribeFirebaseToken } from "services/firebase";
import { socketIO } from "services/socket";
import { toast } from "react-toastify";

const User = ({ collapseSidebar, mouseEnter, contentMouseEnter }) => {
  const [cookies, , removeCookie] = useCookies(["user"]);
  const [open, setOpen] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);

  const getInitialStatus = () => {
    try {
      const userDetail = JSON.parse(localStorage.getItem("userDetail") || "{}");
      return userDetail?.status || "ONLINE";
    } catch (e) {
      return "ONLINE";
    }
  };

  const [userStatus, setUserStatus] = useState(getInitialStatus);

  useEffect(() => {
    const updateFromStorage = () => {
      try {
        const userDetail = JSON.parse(localStorage.getItem("userDetail") || "{}");
        if (userDetail?.status && userDetail.status !== userStatus) {
          setUserStatus(userDetail.status);
        }
      } catch (e) {}
    };

    window.addEventListener("storage", updateFromStorage);
    window.addEventListener("user-status-changed", updateFromStorage);
    return () => {
      window.removeEventListener("storage", updateFromStorage);
      window.removeEventListener("user-status-changed", updateFromStorage);
    };
  }, [userStatus]);

  // const history = useHistory();
  const toggle = () => setOpen((prevState) => !prevState);

  const handleConfirmStatus = async (targetStatus, reason) => {
    if (loadingStatus) return;
    setLoadingStatus(true);

    const finalReason = reason || (targetStatus === "OFFLINE" ? "manual_toggle_offline" : "manual_toggle_online");

    try {
      const res = await serviceToggleUserStatus(
        cookies.SIDikey,
        targetStatus,
        cookies.id,
        finalReason
      );

      if (res && (res.status === 200 || res.status === 202)) {
        setUserStatus(targetStatus);

        // Update userDetail in localStorage
        try {
          const userDetail = JSON.parse(localStorage.getItem("userDetail") || "{}");
          userDetail.status = targetStatus;
          localStorage.setItem("userDetail", JSON.stringify(userDetail));
          if (targetStatus === "OFFLINE") {
            localStorage.setItem("manualOffline", "true");
          } else {
            localStorage.removeItem("manualOffline");
          }
        } catch (err) {
          console.error("Failed to update localStorage userDetail", err);
        }

        // Emit socket events to update real-time views
        if (socketIO && socketIO.connected) {
          const socketPayload = JSON.stringify({
            sign: true,
            type: targetStatus === "OFFLINE" ? "statusOffline" : "statusOnline",
            id: cookies.id,
            firstName: cookies.firstName,
            lastName: cookies.lastName,
            status: targetStatus,
            reason: finalReason,
          });
          socketIO.emit(cookies.id, socketPayload);
          socketIO.emit("admin", socketPayload);
        }

        window.dispatchEvent(new Event("user-status-changed"));
        toast.success(`Status successfully changed to ${targetStatus}`);
      } else {
        toast.error(res?.data?.message || "Failed to update status");
      }
    } catch (error) {
      console.error("Error toggling status:", error);
      toast.error("Failed to update status");
    } finally {
      setLoadingStatus(false);
    }
  };

  const handleSignout = () => {

    unsubscribeFirebaseToken(cookies.SIDikey, localStorage.getItem('firebaseToken'));
    servicePutUsersOffline(cookies.SIDikey, cookies.id);

    if(cookies.role?.name === 'SALES'){
      socketIO.emit(cookies.id, JSON.stringify({sign:true,type:"signOut", id:cookies.id, status:"OFFLINE"}));
    }

    socketIO.emit("admin", JSON.stringify({sign:true,type:"signOut", id:cookies.id, status:"OFFLINE"}));
    removeCookie("SIDikey");
    localStorage.removeItem('firebaseToken');
    localStorage.removeItem('getFirebaseTokenAt');
    localStorage.removeItem('permission');
    localStorage.removeItem('userDetail');
    localStorage.removeItem('loginAt');
    localStorage.removeItem('manualOffline');
    try {
      Object.keys(cookies).forEach(cookieName => {
        removeCookie(cookieName);
      });
    } catch (error) {
      //console.log('Error delete cookies: ', error);
    }
  };

  const isExpand = () => {
    if (collapseSidebar) {
      if (mouseEnter || contentMouseEnter) {
        return true;
      }
    } else {
      return true;
    }
    if (open) {
      setOpen(false);
    }
    return false;
  };

  return (
    <>
      <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
        <DropdownToggle
          tag="a"
          href="#toggle"
          className="dropdown-toggle"
          onClick={(ev) => {
            ev.preventDefault();
          }}
        >
          <div className="user-toggle">
            <UserAvatar
              image={cookies.avatar ? `${process.env.REACT_APP_S3_URL}${cookies.avatar}` : null}
              text={[cookies.firstName, cookies.lastName]
                .filter((n) => n && n !== "null")
                .map((n) => n[0])
                .join("")
                .toUpperCase()}
              className="chat-media overflow-hidden"
            />
            <div className={isExpand() ? "ml-2" : "ml-2 d-none"}>
              <div className="user-status">{cookies.role?.name}</div>
              <div className="d-flex align-items-center">
                <span className="user-name text-truncate pr-1">{cookies.firstName + " " + cookies.lastName}</span>
                {cookies.role?.name === "SALES" && (
                  <span
                    className={`badge badge-dim badge-pill ml-1 ${
                      userStatus === "ONLINE" ? "badge-success" : "badge-danger"
                    }`}
                    style={{ fontSize: "9px", padding: "2px 6px", lineHeight: "12px", whiteSpace: "nowrap" }}
                  >
                    {userStatus}
                  </span>
                )}
                <Icon name="downward-ios" className="ml-1" />
              </div>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu right className="border border-secondary">
          {cookies.role?.name === "SALES" && userStatus !== "ONLINE" && (
            <div className="dropdown-inner border-bottom py-2 px-3">
                <Button
                  color="success"
                  size="sm"
                  className="btn-dim btn-block d-flex align-items-center justify-content-center"
                  disabled={loadingStatus}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleConfirmStatus("ONLINE", "manual_toggle_online");
                  }}
                >
                  {loadingStatus ? (
                    <Spinner size="sm" />
                  ) : (
                    <>
                      <Icon name="check-circle" className="mr-1" />
                      <span>Set to Online</span>
                    </>
                  )}
                </Button>
            </div>
          )}
          <div className="dropdown-inner">
            {cookies.role?.name === "SUPER ADMIN" ? (
              <LinkList>
                <LinkItem link={`${process.env.PUBLIC_URL}/system-settings-profile`} icon="user-alt" onClick={toggle}>
                  View Profile
                </LinkItem>
                <LinkItem
                  link={`${process.env.PUBLIC_URL}/system-settings-notification`}
                  icon="setting-alt"
                  onClick={toggle}
                >
                  System Setting
                </LinkItem>
                <LinkItem link={`${process.env.PUBLIC_URL}/log-management`} icon="activity-alt" onClick={toggle}>
                  Login Activity
                </LinkItem>
              </LinkList>
              ): 
              <LinkList>
                  <LinkItem link={`${process.env.PUBLIC_URL}/system-settings-profile`} icon="user-alt" onClick={toggle}>
                    View Profile
                  </LinkItem>
              </LinkList>
            }
          </div>
          <div className="dropdown-inner">
            <LinkList>
              <a href={`${process.env.PUBLIC_URL}/auth-login`} onClick={handleSignout}>
                <Icon name="signout"></Icon>
                <span>Sign Out</span>
              </a>
            </LinkList>
          </div>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default User;


